/**
 * 车展 / signstore 会话相关（API 环境开关见 @/config/app.js）
 */
export {
	H5_API_ENV,
	H5_LOCAL_API_BASE,
	H5_PRODUCTION_API_BASE,
	isH5DevProxyHost,
	isCarvueDevProxyHost,
	resolveH5AppApiBase,
	APP_API_BASE,
	SIGNSTORE_APP_BASE
} from '@/config/app'

export const SIGNSTORE_USER_INFO_KEY = 'signstore_h5_user_info'
export const SIGNSTORE_AUTH_KIND_KEY = 'signstore_h5_auth_kind'
export const SIGNSTORE_AUTH_SUB_KEY = 'signstore_h5_auth_sub'

/** 印章 ruleCode -> signstore pointIndex */
export const CAR_RULE_POINT_INDEX = {
	RULERsssFFEW1: 1,
	RUL54retFYT: 1,
	RULEKKCnb37: 2,
	RULEffTe2oNP: 3,
	RULEEES23JB: 4
}

/** pointIndex -> 车展页 legacy point */
export const CAR_POINT_INDEX_LEGACY = {
	1: 'one',
	2: 'three',
	3: 'hexiao1',
	4: 'hexiao2'
}
